import { useRef } from 'react'
// import gsap from 'gsap-trial'
// import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin'
// import LogoS from '../../../assets/images/logo-s.svg'
import JoeyLogo from '../../../assets/images/joeyfish_logo.png'
import './index.scss'
import { Image } from 'react-bootstrap'

const Logo = () => {
  // const bgRef = useRef()
  // const solidLogoRef = useRef()
  // const outlineLogoRef = useRef()

  // useEffect(() => {
  //   gsap.registerPlugin(DrawSVGPlugin)

  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })
  //     .from(outlineLogoRef.current, {
  //       drawSVG: 0,
  //       duration: 9,
  //     })

  //   gsap.fromTo(
  //     solidLogoRef.current,
  //     {
  //       opacity: 0,
  //     },
  //     {
  //       opacity: 1,
  //       delay: 4.5,
  //       duration: 4.5,
  //     }
  //   )
  // }, [])

  // return (
  //   <div className="logo-container" ref={bgRef}>
  //     <Image
  //       className="solid-logo"
  //       ref={solidLogoRef}
  //       src={JoeyLogo} // Using your local image here
  //       alt="JoeyFish Logo"
  //     />

  return (
    <div className="logo-container">
      <p style={{ color: 'red' }}>LOGO COMPONENT LOADED</p>


      {/*

      <svg
        width="auto"
        height="auto"
        version="1.0"
        viewBox="0 0 548 660.54"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          className="svg-container"
          fill="none"
        >
          <path
            ref={outlineLogoRef}
            d="M1130.17,2735.42l-0.11,0c-175.56-7.77-326.99-44.14-462.95-111.17c-76.45-37.69-144.69-86-202.81-143.56
            c-87.26-86.42-151.37-187.26-190.55-299.72c-27.06-77.67-43.85-157.11-49.92-236.13c-2.71-35.33-3.76-71.36-4.77-106.2
            c-0.26-8.9-0.52-17.79-0.8-26.69c-0.28-8.74,0.3-14.84,4.07-18.21c3.74-3.35,9.85-3.25,18.49-2.01
            c54.73,7.85,110.35,15.95,164.14,23.78c20.15,2.93,40.29,5.87,60.44,8.8c22.35,3.25,44.7,6.51,67.05,9.77
            c53.5,7.8,108.82,15.87,163.24,23.66c21.13,3.03,25.23,5.64,24.73,28.77c-1.45,65.97,3.13,115.85,14.84,161.72
            c16.74,65.57,44.95,116.2,86.25,154.77c32.44,30.3,72.44,52.29,122.27,67.24c34.96,10.48,65.84,16.68,94.43,18.96
            c34.11,2.73,65.33,0.02,95.44-8.28c39.5-10.88,73.94-30.09,102.37-57.11c26.53-25.21,48.71-58.06,65.94-97.65
            c24.34-55.93,36.89-118.85,39.49-198.02c1.51-46.08,3.48-92.92,5.39-138.21c1.06-25.22,2.16-51.3,3.16-76.95
            c2.5-63.86,4.94-128.79,7.3-191.58l1.05-27.9c0.25-6.57,0.5-13.14,0.76-19.72c0.81-20.99,1.66-42.7,2.22-64.04
            c0.47-17.79,0.82-35.9,1.16-53.4c0.52-27.05,1.06-55.01,2.06-82.51c1.36-37.09,3.09-74.78,4.77-111.22
            c1.15-25.05,2.34-50.95,3.4-76.43c1.46-35.01,2.45-69.3,3.24-98.22c0.45-16.72,0.81-33.72,1.15-50.17
            c0.54-25.73,1.09-52.35,2.03-78.51c1.48-40.66,3.24-81.98,4.95-121.94c1.19-27.7,2.41-56.35,3.53-84.52
            c2.44-61.34,4.77-123.71,7.02-184.02l1.73-46.32c0.93-24.84,1.9-50.52,2.58-75.79c0.48-18,0.87-36.31,1.25-54.02
            c0.55-25.89,1.12-52.66,1.99-78.99c0.56-17.04,1.47-34.34,2.36-51.07c0.89-16.83,1.8-34.24,2.36-51.37
            c0.23-6.88,1.96-11.56,5.3-14.33c3.55-2.94,8.69-3.7,16.68-2.46c42.91,6.63,86.56,13.23,128.78,19.61
            c20.91,3.16,41.82,6.32,62.72,9.5c22.95,3.49,45.91,6.99,68.86,10.49c63.61,9.71,129.38,19.75,194.11,29.28
            c11.45,1.69,15.78,6.69,15.45,17.82c-1.02,34.47-1.95,69.52-2.85,103.42c-1.02,38.58-2.08,78.47-3.28,117.71
            c-1.35,44.09-3.17,88.91-4.94,132.25l-0.73,17.95c-1.08,26.56-2.23,53.56-3.35,79.68c-1.64,38.23-3.34,77.76-4.8,116.65
            c-1.05,27.91-1.77,56.31-2.46,83.78c-0.3,12.05-0.61,24.11-0.94,36.16c-0.32,11.7-0.6,23.41-0.88,35.12
            c-0.59,24.5-1.19,49.83-2.17,74.74c-1.1,27.71-2.39,55.88-3.65,83.13c-1.67,36.15-3.39,73.52-4.66,110.29
            c-1.45,42.12-2.53,84.97-3.58,126.41c-0.76,30.09-1.54,61.21-2.46,91.81c-1.07,35.55-2.4,71.69-3.69,106.64
            c-0.68,18.38-1.36,36.76-2,55.14c-0.78,22.28-1.55,44.55-2.31,66.83c-1.17,33.96-2.38,69.08-3.62,103.62l-0.7,19.52
            c-1.56,43.78-3.18,89.05-5.03,133.56c-0.39,9.28-0.75,18.56-1.12,27.84c-4.1,103.12-8.35,209.75-35.77,312.43
            c-14.16,53.01-32.69,103.08-55.09,148.81c-23.53,48.03-52.15,93-85.07,133.64c-36.81,45.44-79.72,85.07-127.54,117.77
            c-46.37,31.71-98.65,57.8-155.38,77.55c-60.75,21.14-125.14,33.93-191.37,38.02c-7.73,0.5-15.48,1-23.31,1.52
            c-11.6,0.76-23.41,1.53-35.73,2.31L1130.17,2735.42z M231.86,1794.93c-3.39,0-5.53,0.58-6.86,1.77c-2.23,1.99-3.02,6.37-2.74,15.1
            c0.29,8.9,0.54,17.8,0.8,26.7c1.01,34.79,2.06,70.78,4.76,106.01c6.04,78.68,22.76,157.79,49.7,235.12
            c38.98,111.88,102.77,212.21,189.59,298.2c57.82,57.26,125.7,105.31,201.77,142.82c135.43,66.78,286.3,103.01,461.25,110.76
            c12.28-0.79,24.05-1.55,35.62-2.31c7.84-0.51,15.58-1.02,23.32-1.52c65.88-4.06,129.91-16.78,190.31-37.8
            c56.4-19.63,108.36-45.56,154.44-77.07c47.5-32.49,90.13-71.85,126.69-116.99c32.73-40.41,61.19-85.12,84.59-132.89
            c22.29-45.5,40.73-95.32,54.82-148.08c27.31-102.25,31.54-208.66,35.64-311.56c0.37-9.28,0.74-18.57,1.12-27.85
            c1.85-44.5,3.47-89.76,5.03-133.54l0.7-19.52c1.24-34.54,2.45-69.66,3.62-103.62c0.77-22.28,1.53-44.55,2.31-66.83
            c0.64-18.38,1.32-36.77,2-55.15c1.29-34.94,2.62-71.07,3.69-106.61c0.92-30.59,1.7-61.7,2.46-91.79
            c1.04-41.45,2.12-84.3,3.58-126.44c1.27-36.8,3-74.18,4.66-110.34c1.26-27.24,2.55-55.4,3.65-83.1
            c0.98-24.87,1.58-50.19,2.17-74.67c0.28-11.71,0.56-23.42,0.88-35.13c0.33-12.05,0.63-24.1,0.94-36.15
            c0.69-27.48,1.41-55.89,2.46-83.83c1.47-38.9,3.17-78.43,4.81-116.67c1.12-26.11,2.28-53.11,3.36-79.67l0.73-17.95
            c1.77-43.33,3.59-88.14,4.94-132.21c1.2-39.23,2.26-79.11,3.28-117.69c0.9-33.9,1.83-68.95,2.85-103.43
            c0.27-9.13-2.54-12.34-12.03-13.74c-64.75-9.54-130.52-19.58-194.13-29.29c-22.95-3.5-45.9-7.01-68.86-10.49
            c-20.9-3.18-41.81-6.34-62.72-9.5c-42.22-6.38-85.87-12.98-128.79-19.61c-6.76-1.05-10.93-0.56-13.51,1.59
            c-2.4,1.99-3.66,5.72-3.85,11.38c-0.56,17.16-1.48,34.59-2.37,51.44c-0.88,16.71-1.79,34-2.35,51
            c-0.87,26.3-1.44,53.06-1.99,78.94c-0.38,17.71-0.77,36.03-1.25,54.04c-0.68,25.29-1.65,50.98-2.58,75.83l-1.73,46.32
            c-2.25,60.32-4.58,122.69-7.02,184.03c-1.12,28.18-2.34,56.83-3.53,84.54c-1.71,39.96-3.48,81.27-4.95,121.92
            c-0.95,26.14-1.5,52.73-2.03,78.45c-0.34,16.45-0.7,33.46-1.15,50.19c-0.79,28.94-1.79,63.24-3.24,98.28
            c-1.06,25.48-2.25,51.39-3.4,76.44c-1.68,36.44-3.41,74.12-4.77,111.19c-1,27.46-1.54,55.41-2.06,82.44
            c-0.34,17.51-0.69,35.62-1.16,53.43c-0.57,21.37-1.41,43.09-2.22,64.09c-0.25,6.57-0.51,13.14-0.76,19.71l-1.05,27.9
            c-2.36,62.79-4.8,127.72-7.3,191.59c-1,25.66-2.1,51.74-3.16,76.96c-1.91,45.29-3.88,92.11-5.38,138.17
            c-2.62,79.69-15.27,143.07-39.82,199.48c-17.44,40.08-39.93,73.37-66.85,98.95c-28.92,27.48-63.93,47.02-104.06,58.07
            c-30.56,8.42-62.23,11.17-96.82,8.41c-28.87-2.3-60.02-8.56-95.26-19.12c-50.44-15.12-90.95-37.41-123.85-68.14
            c-41.87-39.12-70.46-90.37-87.39-156.71c-11.8-46.24-16.42-96.45-14.96-162.8c0.45-20.81-1.99-21.96-21.29-24.73
            c-54.43-7.79-109.75-15.86-163.25-23.66c-22.35-3.26-44.7-6.52-67.05-9.77c-20.15-2.93-40.3-5.86-60.44-8.8
            c-53.79-7.83-109.41-15.93-164.13-23.78C236.84,1795.18,234.08,1794.93,231.86,1794.93z"/>
        </g>
        <g>
          <path className="st0" d="M1009.96,2265.71l9.22-7.16c74.04-57.45,113.34-139.68,123.68-258.78c5.9-67.93,8.12-137.37,10.26-204.51
            c0.7-22.02,1.43-44.79,2.28-67.18c6.71-177.31,13.09-357.61,19.27-531.97l0.02-0.44c2.58-72.67,5.11-146.55,7.57-218.01
            c2.66-77.45,5.41-157.54,8.21-236.3c5-139.99,10.19-282.31,15.22-419.94c2.23-61.12,4.46-122.24,6.68-183.36
            c0.03-0.79,0.08-1.57,0.13-2.36c0.04-0.66,0.08-1.32,0.11-1.99c1.46-36.32,2.16-37.11,37.78-42.45
            c17.63-2.64,35.2-5.28,52.76-7.91c24.86-3.73,49.72-7.47,74.59-11.17c2.83-0.42,5.62-0.66,8.85-0.94
            c1.61-0.14,3.31-0.28,5.16-0.47l2.04-0.2l0.15,2.05c0.13,1.77,0.29,3.42,0.44,4.98c0.32,3.25,0.6,6.06,0.5,8.98l-0.84,25.32
            c-3.01,90.8-6.12,184.69-9.35,277.03c-2.46,70.26-5.05,141.69-7.54,210.77c-1.56,43.06-3.12,86.12-4.66,129.18
            c-3.86,108.01-7.69,216.02-11.52,324.03l-15.15,427.6c-2.67,75.41-5.34,150.83-8.04,226.24c-0.68,18.87-1.33,37.73-1.98,56.6
            c-1.77,51.15-3.6,104.04-5.89,156.04c-3.03,68.56-11.36,148.2-50.26,218.98c-9.86,17.93-23.52,34.04-36.73,49.61
            c-4.68,5.52-9.52,11.23-14.11,16.92c-3.52,4.37-9.93,7.79-14.91,7.96c-48.56,1.68-98.08,13.36-155.84,36.76
            c-8.28,3.34-16.93,6.05-25.29,8.67c-3.86,1.21-7.85,2.46-11.75,3.75L1009.96,2265.71z M1390.13,74.94
            c-1.11,0.1-2.17,0.19-3.19,0.28c-3.17,0.27-5.9,0.51-8.6,0.91c-24.86,3.71-49.72,7.44-74.58,11.17
            c-17.57,2.64-35.14,5.28-52.71,7.91c-16.89,2.53-25.34,3.79-29.37,8.32c-4.04,4.53-4.38,13.16-5.07,30.34
            c-0.03,0.7-0.07,1.39-0.12,2.08c-0.05,0.75-0.1,1.5-0.12,2.25c-2.22,61.13-4.45,122.25-6.68,183.37
            c-5.02,137.63-10.22,279.95-15.22,419.94c-2.81,78.76-5.56,158.85-8.22,236.3c-2.45,71.46-4.99,145.34-7.56,218.01l-0.02,0.44
            c-6.18,174.36-12.57,354.66-19.27,531.98c-0.85,22.37-1.58,45.14-2.28,67.16c-2.15,67.2-4.37,136.69-10.28,204.73
            c-10.05,115.7-47.24,197.01-116.79,254.83c0.51-0.16,1.02-0.32,1.53-0.48c8.29-2.59,16.86-5.27,24.99-8.56
            c58.21-23.58,108.16-35.36,157.2-37.05c3.81-0.13,9.16-3.04,11.93-6.48c4.61-5.73,9.47-11.45,14.17-16.99
            c13.08-15.43,26.61-31.38,36.27-48.95c38.51-70.06,46.77-149.12,49.77-217.22c2.29-51.98,4.12-104.86,5.89-156.01
            c0.65-18.87,1.31-37.74,1.98-56.61c2.71-75.41,5.38-150.83,8.04-226.24l15.15-427.6c3.83-108.01,7.66-216.02,11.52-324.03
            c1.54-43.06,3.1-86.12,4.66-129.18c2.5-69.08,5.08-140.5,7.54-210.76c3.23-92.34,6.34-186.23,9.35-277.02l0.84-25.33
            c0.09-2.65-0.18-5.34-0.48-8.45C1390.32,77.01,1390.22,76,1390.13,74.94z"/>
        </g>
        <g>
          <path className="st0" d="M946.63,2777.17c-64.03,0-127.41-5.94-189.51-17.8c-102.24-19.53-203.45-55.58-300.81-107.15
            c-177.96-94.26-304.07-240.53-374.82-434.73C47.43,2124,29.02,2023.7,25.2,1910.85c-1.17-34.63-0.5-69.05,0.35-104.21
            c0.13-5.17,6.22-14.03,11.33-14.84c45.55-7.11,91.96-13.62,136.85-19.91c8.29-1.16,16.58-2.32,24.87-3.49
            c0.97-0.14,1.79,0.13,3.13,0.56c0.8,0.26,1.89,0.61,3.47,1.05l1.47,0.4v1.52c0,2.16,0.02,4.29,0.03,6.42
            c0.04,4.5,0.07,9.16-0.06,13.72c-3.33,113.4,6.12,213.77,28.87,306.83c21.4,87.51,54.25,168.14,97.66,239.65
            c44.48,73.27,101.36,139.16,169.07,195.82c46.11,38.59,97.2,72.49,151.83,100.75c52.02,26.91,108.99,49.61,169.34,67.46
            c77.81,23.02,157.84,38.19,237.88,45.08c17.02,1.47,34.43,2.29,51.27,3.09c15.4,0.73,31.33,1.48,47.07,2.73l18.15,1.44
            l-18.03,2.54c-8.76,1.23-17.52,2.51-26.28,3.78c-18.49,2.69-37.61,5.46-56.47,7.81C1033.37,2774.46,989.85,2777.17,946.63,2777.17
            z M199.1,1772.36c-8.23,1.16-16.52,2.33-24.81,3.49c-44.87,6.29-91.27,12.8-136.79,19.9c-2.65,0.42-7.85,7.05-7.95,10.98
            c-0.85,35.09-1.52,69.45-0.35,103.97c3.8,112.42,22.13,212.32,56.05,305.4c70.4,193.25,195.88,338.79,372.94,432.57
            c97,51.38,197.83,87.3,299.69,106.76c103.6,19.79,210.8,23.03,318.62,9.64c18.82-2.34,37.92-5.11,56.39-7.8
            c2.51-0.36,5.02-0.73,7.53-1.09c-9.43-0.55-18.84-1-28.05-1.44c-16.87-0.8-34.32-1.62-51.42-3.1
            c-80.3-6.92-160.6-22.14-238.67-45.23c-60.59-17.92-117.8-40.71-170.04-67.74c-54.89-28.4-106.22-62.46-152.56-101.23
            c-68.04-56.94-125.21-123.16-169.92-196.81c-43.62-71.86-76.63-152.86-98.13-240.77c-22.84-93.42-32.32-194.13-28.99-307.9
            c0.14-4.49,0.1-8.9,0.06-13.57c-0.01-1.64-0.03-3.29-0.03-4.94c-0.91-0.27-1.61-0.5-2.17-0.68
            C199.9,1772.58,199.28,1772.37,199.1,1772.36z"
          />                 
        </g>
      </svg> */}
    </div>
  )
}

export default Logo
